export default {
	listOfDeals:        state => state.listOfDeals,
	estateRolodexItems: state => state.estateRolodexItems
};
